export const initialValues = {
  taluka_id: null,
  name: "",
  is_active: 1,
};
